import { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { DataList } from "@/components/common/DataList";
import { useList } from "@/hooks/useList";
import { api, fmtDateTime, formatError } from "@/lib/api";

export function BlockedTab() {
  const list = useList("/blocked-recipients", { pageSize: 100 });
  const [form, setForm] = useState({ pattern: "", reason: "" });
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/blocked-recipients", form); toast.success("Blocked pattern added"); setForm({ pattern: "", reason: "" }); list.reload(); } catch (err) { toast.error(formatError(err)); }
  };
  const remove = async (r) => {
    try { await api.delete(`/blocked-recipients/${r.id}`); toast.success("Removed"); list.reload(); } catch (err) { toast.error(formatError(err)); }
  };
  const columns = [
    { key: "pattern", label: "Pattern", render: (r) => <code className="font-mono text-xs">{r.pattern}</code> },
    { key: "reason", label: "Reason" },
    { key: "added_by", label: "Added by" },
    { key: "created_at", label: "Added", render: (r) => fmtDateTime(r.created_at) },
    { key: "x", label: "", render: (r) => <Button size="icon" variant="ghost" onClick={() => remove(r)} data-testid={`blocked-delete-${r.id}`}><Trash2 className="h-4 w-4 text-red-500" /></Button> },
  ];
  return (
    <div className="space-y-4">
      <p className="text-sm bg-slate-100 border border-slate-200 rounded-md px-3 py-2 text-slate-600" data-testid="blocked-builtin-note">
        Built in and always on: any address containing <code className="font-mono">payroll</code> is never emailed, even with safe mode off. Blocked sends are logged with status “blocked”.
      </p>
      <form onSubmit={add} className="flex flex-col sm:flex-row gap-3">
        <Input required placeholder="Address or fragment, e.g. accounts@client.com.au" value={form.pattern} onChange={(e) => setForm({ ...form, pattern: e.target.value })} className="bg-white sm:max-w-sm" data-testid="blocked-pattern-input" />
        <Input placeholder="Reason" value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} className="bg-white sm:max-w-sm" data-testid="blocked-reason-input" />
        <Button type="submit" data-testid="blocked-add-button">Add</Button>
      </form>
      <DataList columns={columns} rows={list.items} loading={list.loading} rowTestId="blocked-row" mobileTitle={(r) => r.pattern} empty="No extra blocked recipients yet." />
    </div>
  );
}
